import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const staff = [{
  name: 'Afriel',
  title: 'Owner & Lead Practitioner',
  bio: 'The heart and soul of Afriel Spa. With over a decade of experience in sensual bodywork and rejuvenation, she has crafted this LA sanctuary into a one-of-a-kind discreet retreat. Warm, intuitive, and deeply skilled.',
  specialties: ['Nuru Mastery', 'Tantric Journeys', 'Couples Rituals'],
  image: 'https://cdn.magicpatterns.com/uploads/n9AJ7avZPzCmAgxQKaWg3s/Day_Spa.jpg'
}, {
  name: 'Naia',
  title: 'Senior Practitioner',
  bio: 'Specializing in deep sensual full-body and four-hands choreography. Naia brings a graceful, athletic energy and a deeply attuned sense of presence to every session.',
  specialties: ['Four-Hands', 'Sensual Full-Body', 'Bespoke Sessions'],
  image: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=1925&auto=format&fit=crop'
}, {
  name: 'Imani',
  title: 'Bespoke Specialist',
  bio: 'Trained in advanced sensory work, Imani leads consultations for bespoke and personalized journeys. Her discretion and open-minded approach are unmatched.',
  specialties: ['Bespoke Consultations', 'Sensory Play', 'Tantric Work'],
  image: 'https://images.unsplash.com/photo-1592621385612-4d7129426394?q=80&w=1887&auto=format&fit=crop'
}];
export function Staff() {
  return <section id="staff" className="py-24 md:py-32 relative" data-id="element-487">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-488">
        <div className="text-center mb-20" data-id="element-489">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-rose-400 uppercase tracking-[0.2em] text-sm mb-4 block" data-id="element-490">
            The Artisans
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-serif text-4xl md:text-5xl text-lavender-50 mb-4" data-id="element-491">
            Meet Our{' '}
            <span className="italic bg-gradient-to-r from-lavender-300 to-rose-400 bg-clip-text text-transparent" data-id="element-492">
              Staff
            </span>
          </motion.h2>
          <p className="text-lavender-100/60 font-light max-w-xl mx-auto" data-id="element-493">
            Hand-selected practitioners committed to artistry, discretion, and
            your absolute comfort.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-494">
          {staff.map((member, index) => <motion.div key={member.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="group" data-id="element-495">
              <div className="aspect-[3/4] overflow-hidden rounded-2xl mb-6 relative" data-id="element-496">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-497" />
                <div className="absolute inset-0 bg-gradient-to-t from-plum-950 via-plum-950/30 to-transparent" data-id="element-498"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-499">
                  <h3 className="font-serif text-3xl text-lavender-50 mb-1" data-id="element-500">
                    {member.name}
                  </h3>
                  <p className="text-rose-300 text-sm uppercase tracking-widest" data-id="element-501">
                    {member.title}
                  </p>
                </div>
              </div>

              <p className="text-lavender-100/70 font-light text-sm leading-relaxed mb-4" data-id="element-502">
                {member.bio}
              </p>

              <div className="flex flex-wrap gap-2" data-id="element-503">
                {member.specialties.map(spec => <span key={spec} className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-lavender-400/10 border border-lavender-400/20 text-lavender-200 text-xs" data-id="element-504">
                    <Star size={10} className="text-rose-400" data-id="element-505" />
                    {spec}
                  </span>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}